import { UiBox } from "@smp/ui";
import { PropsWithChildren, useMemo } from "react";

import { useStyles } from "./viewport_mock.css";

export const ViewportMock = ({ children }: PropsWithChildren<{}>) => {
  const classes = useStyles();

  return useMemo(
    () => <UiBox className={classes.viewport}>{children}</UiBox>,
    [children, classes],
  );
};
